import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { AITopicsByPerson } from '../ai-topics';
// TODO pass layout spacing as a wrapper into the component to render conditionally only it topics are present
var TopicsContainerStyles = xcss({
  // marginTop: 'space.negative.200', // negative margins to pull topics card into place
  // marginBottom: 'space.050',
});
export var KnowledgeCardsTopics = function KnowledgeCardsTopics(props) {
  return /*#__PURE__*/React.createElement(Box, {
    xcss: TopicsContainerStyles
  }, /*#__PURE__*/React.createElement(AITopicsByPerson, props));
};